<!--
 * @Author: fengxiaojing
 * @LastEditTime: 2023-07-03 18:13:08
 * @Description: 视频监控
 * @LastEditors: Please set LastEditors
-->
<template>
  <div>
    <el-card
      shadow="never"
      class="h-100 position-absolute monitor"
      :style="{ height: height, top: top }"
    >
      <div slot="header" class="clearfix business_dialog_title m-b-5">
        <span class="fz-14">摄像头列表</span>
        <span class="iconfont icon-close r cur_pointer" @click="closeComponent"></span>
        <el-button type="primary" size="mini" class="r m-r-5 button-color">查看全部</el-button>
      </div>
      <div class="h-100">
        <div class="monitor_table">
          <el-table :data="dataList" v-loading="tableLoading" class="w-100" height="100%">
            <el-table-column type="index" label="序号" align="center" width="55"></el-table-column>
            <el-table-column prop="name" label="摄像头名称" align="center"></el-table-column>
            <el-table-column prop="distance" label="距离" align="center">
              <template #default="{row}">
                <span>{{ row.distance + 'm' }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="80">
              <template #default="{row}">
                <el-tooltip placement="top" content="播放" :open-delay="1000">
                  <el-button
                    type="success"
                    icon="el-icon-caret-right"
                    @click="runH5Player(row)"
                  ></el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="r m-t-5">
          <el-pagination
            ref="monitorPagination"
            background
            :current-page.sync="pageNo"
            :page-size.sync="pageSize"
            :pager-count="5"
            layout="total, prev, pager, next"
            :total="pageTotal"
          ></el-pagination>
        </div>
      </div>
    </el-card>
    <!-- 监控弹框 -->
    <div
      class="h-100 position-absolute camera_info"
      :style="{ left: isShowBasicCom ? '405px' : '35px' }"
      v-if="showCamera"
      v-drag
    >
      <div class="camera_title fz-16 p-10 flex-row-between flex-align-center">
        <span class="fz-14 text-color-white">监控画面</span>
        <i class="cur_pointer iconfont icon-close text-color-white" @click="closePlayer"></i>
      </div>
      <h5-player
        v-if="switchPlayMonitor == 2"
        :showControl="true"
        class="play_wind"
        :isDarkStyle="true"
        :cameraIndexCodeList="cameraIndexCodeList"
      ></h5-player>
      <DH-player
        v-if="switchPlayMonitor == 3"
        :showControl="true"
        class="play_wind"
        :isDarkStyle="true"
        :cameraIndexCodeList="cameraIndexCodeList"
      ></DH-player>
    </div>
  </div>
</template>
<script>
import MonitorManage from '@/services/monitorManage'
import PointManage from '@/services/pointManage'
import h5Player from '@/components/video/h5Player'
import DHPlayer from '@/components/video/DHPlayer'

export default {
  name: 'MonitorList',
  props: ['documentId', 'player', 'height', 'top', 'loadedModel', 'isShowBasicCom'],
  components: {
    h5Player,
    DHPlayer,
  },
  data() {
    return {
      pageNo: 1,
      pageSize: 15,
      pageTotal: 10,
      showCamera: false, // 控制播放器显示隐藏
      cameraIndexCodeList: [],
      monitorList: [
        // { name: '空压机房1', cameraIndexCode: '294a1739d1d94fcb96c1bae2c07b55cd', distance: 1.0 },
        // { name: '空压机房2', cameraIndexCode: '480576d500cc495cbced3cdb7dea3c62', distance: 1.4 },
        // { name: '空压机房3', cameraIndexCode: '1268010dd48146d2a741094f4df3224c', distance: 1.6 },
        // { name: '煤泥池1', cameraIndexCode: '82e6621a39a14668ac4ceecad57380d4', distance: 21 },
        // { name: '煤泥池2', cameraIndexCode: '66dcf7b2855d4562b133adcc9d4d69f4', distance: 18 },
        // { name: '煤泥池3', cameraIndexCode: '01058f0b601645939a389fdc879b1331', distance: 18 },
        // { name: '一号堆放区', cameraIndexCode: '9250cf87b88a41be80a80a07c10fb587', distance: 10 },
        // { name: '二号堆放区', cameraIndexCode: '1b910294c2f04c9589957bccc47cfeca', distance: 14 },
        // { name: '三号堆放区', cameraIndexCode: '37b45ec5de6b49edb01dba356bd5927c', distance: 12 },
        // { name: '四号堆放区', cameraIndexCode: 'fc2e0187ded54b0782d50a17cd94d63d', distance: 8 },
      ], // 摄像头列表
      pointList: [], // 点位列表
      relationList: [],
      pointInfo: [],
      markers: [],
      tableLoading: false,
    }
  },
  async created() {
    await this.getMonitorList()
    this.getPointList()
  },
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
    // 前端分页处理
    dataList() {
      return this.monitorList.slice((this.pageNo - 1) * this.pageSize, this.pageNo * this.pageSize)
    },
    switchPlayMonitor() {
      const systemParams = this.$store.getters.systemParams || []
      const switchPlayMonitor = _.find(systemParams, { parameterCode: 'switchPlayMonitor' })
      return switchPlayMonitor ? switchPlayMonitor.parameterValue : 1
    },
  },
  watch: {},
  async beforeDestroy() {
    // 检查是否有已知的标记
    const markerList = await PlayerUtils.call(this.player.Native.GisMarker.getMarkerList)
    _.forEach(markerList, (el) => {
      this.player.Native.GisMarker.destroy(el.id)
    })
  },
  methods: {
    closeComponent() {
      this.$emit('closeComponent', 'MonitorList')
    },
    // 获取模型code的三维向量
    async getModelPos(code) {
      const modelInfo = await PlayerUtils.call(this.player.Native.ModelTree.calcItemAabb, code)
      if (!_.isEmpty(modelInfo)) {
        const modelCodePos = [
          1 * modelInfo.aabb.min[0] + (modelInfo.aabb.max[0] - modelInfo.aabb.min[0]) / 2,
          1 * modelInfo.aabb.min[1] + (modelInfo.aabb.max[1] - modelInfo.aabb.min[1]) / 2,
          1 * modelInfo.aabb.min[2] + (modelInfo.aabb.max[2] - modelInfo.aabb.min[2]) / 2,
        ]
        return modelCodePos
      }
      return [0, 0, 0]
    },
    async getPointList() {
      const params = {
        pageno: 1,
        pagesize: 99999,
        pointtypeid: '',
        relation_model_document_id: this.$route.query.documentId || '',
      }
      const res = await PointManage.getPointList(params)
      if (res && res.data && res.code === 0) {
        _.forEach(res.data, async (item) => {
          const pos = item.location.split(',')
          // 加载锚点
          const imgId = await PlayerUtils.call(
            this.player.Native.GisMarker.loadImage,
            `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/${item.style}`
          )
          this.drawPoint(pos, imgId, item.code)
        })
        this.player.Native.GisMarker.EventGisMarkerLClick.connect(this.clickMarker)
      }
    },
    // 点击模型时
    clickModel(code) {
      console.log(code)
      if (code) {
        this.$nextTick(async () => {
          this.monitorList = []
          this.pageTotal = 0
          this.tableLoading = true
          const list = await this.getRelationList(1, code)
          this.monitorList = _.map(list, (item) => {
            return {
              id: item.videoMonitorId,
              name: item.videoMonitorName,
              cameraIndexCode: item.videoMonitorCode,
              distance: 0,
            }
          })
          _.forEach(this.relationList, async (item) => {
            const start = await this.getModelPos(code)
            const end = await this.getModelPos(item.tagCode)
            if (start && end) {
              const distance = this.getPointDistance(start, end)
              this.monitorList.push({
                id: item.id,
                name: item.name,
                cameraIndexCode: item.code,
                distance: _.round(distance, 3),
              })
              this.monitorList = _.sortBy(this.sortList(this.monitorList), (el) => {
                return el.distance
              })
            }
            this.pageTotal = this.monitorList.length
          })
          this.tableLoading = false
        })
      }
    },
    // 获取关联列表
    async getRelationList(type, code) {
      const dataParams = {
        type,
        siteid: this.currentProject.id,
        pageno: 1,
        pagesize: 99999,
        relationcode: code,
      }
      const res = await MonitorManage.getRelationList(dataParams)
      if (res && res.code === 0 && res.data) {
        return res.data
      }
      return []
    },
    // 点击点位
    async clickMarker(e) {
      this.player.Native.ModelTree.restoreAllItemColor()
      this.monitorList = []
      this.pageTotal = 0
      this.tableLoading = true
      const point = _.find(this.pointInfo, ['markerId', e.markerId])
      if (point) {
        const list = await this.getRelationList(3, point.code)
        this.monitorList = _.map(list, (item) => {
          return {
            id: item.videoMonitorId,
            name: item.videoMonitorName,
            cameraIndexCode: item.videoMonitorCode,
            distance: 0,
          }
        })
        _.forEach(this.relationList, async (item) => {
          const start = e.markerInfo.pos
          const end = await this.getModelPos(item.tagCode)
          if (start && end) {
            const distance = this.getPointDistance(start, end)
            this.monitorList.push({
              id: item.id,
              name: item.name,
              cameraIndexCode: item.code,
              distance: _.round(distance, 3),
            })
            this.monitorList = _.sortBy(this.sortList(this.monitorList), (el) => {
              return el.distance
            })
          }
          this.pageTotal = this.monitorList.length
        })
        this.markers = []
        this.tableLoading = false
      }
    },
    sortList(list) {
      const arr = _.uniqBy(list, 'id')
      const newList = _.filter(arr, (item) => {
        return item.distance <= 100
      })
      return newList
    },
    // 绘制点位
    async drawPoint(pos, imgId, code) {
      const option = {
        pos, // 定位点，世界坐标，三维向量
        visible: true, // 显示隐藏状态
        size: [20, 20], // 整体尺寸，二维向量，-1表示不限制，自动大小
        nodeOffset: [-10, -10], // 相对定位点的偏移量，二维向量
        imgId, // 图片
        imgSize: [20, 20], // 图片尺寸，-1为应用图片大小，如[32, -1]为宽度拉伸或压缩到32，高度为图片高度
        imgOffset: [0, 0], // 图片相对标记的偏移量
        text: '', // 文本
        fontSize: 14.0, // 字体大小
        breakWidth: 250, // 最大行宽，超过宽度会换行，-1表示限制，换行符（'\n'）会强制换行不受控制
        textOffset: [0, 0], // 文字相对标记的偏移量
        textColor: 0xffffffff, // 文本颜色
        title: '', // 标题
        titleFontSize: 18.0, // 标题文字大小
        titleColor: 0xffffffff, // 标题颜色
        userData: null, // 用户数据，仅帮外部系统保存数据
      }
      const markerId = await PlayerUtils.call(this.player.Native.GisMarker.create, option)
      this.pointInfo.push({ markerId, code })
    },
    // 获取监控设备列表
    async getMonitorList() {
      const dataParams = {
        siteId: this.currentProject.id,
        pageno: 1,
        pagesize: 99999,
      }
      this.tableLoading = true
      this.monitorList = []
      const res = await MonitorManage.getMonitorList(dataParams)
      this.tableLoading = false
      if (res && res.code === 0 && res.data) {
        this.relationList = res.data
        this.monitorList = _.map(res.data, (item) => {
          // 接收列表item
          return {
            id: item.id,
            name: item.name,
            cameraIndexCode: item.code,
            distance: 0,
          }
        })
        if (res.page) {
          this.pageTotal = res.page.recordCount
        }
      }
      console.log(res)
    },
    // 打开播放组件
    runH5Player(row) {
      this.showCamera = true
      console.log(row, 'eeeeeee')
      this.cameraIndexCodeList.push(row.cameraIndexCode)
    },
    // 关闭播放组件
    closePlayer() {
      this.showCamera = false
      this.cameraIndexCodeList = []
    },
    /**
     * 求出点与点之间
     *  */
    getPointDistance(start, end) {
      const distance = Math.sqrt(
        Math.pow(start[0] - end[0], 2) +
          Math.pow(start[1] - end[1], 2) +
          Math.pow(start[2] - end[2], 2)
      )
      return distance
    },
  },
}
</script>
<style lang="scss">

@import '../../css/select.scss';

</style>
<style lang="scss" scoped>

@import '../../css/index.scss';
.monitor {
  width: 368px;
  top: 76px;
  right: 35px;
  padding: 10px;
  border-radius: 4px;
  z-index: 99;
  background-color: rgba(46, 107, 176, 0.5) !important;
  &_table {
    height: calc(100% - 30px);
  }
}
/deep/ .el-card__body {
  padding: 0 !important;
  margin: 0 !important;
  height: calc(100% - 30px);
  tr.current-row > td {
    background-color: #e8e882;
  }
  tr.el-table__row--striped.current-row td {
    background-color: #e8e882 !important;
  }
}
.button-color {
  border: none;
  color: #fff;
  background-color: #00c0ff !important;
}
.camera_info {
  height: 395px;
  width: 720px;
  left: 378px;
  padding: 5px;
  top: 66px;
  z-index: 100;
  background-color: rgba(46, 107, 176, 0.5) !important;
}
.camera_title {
  height: 24px;
}
.play_wind {
  height: 360px;
}

</style>
